/**
 * Тонкая обёртка над fetch для админ-API.
 * Токен хранится в localStorage и кладётся в заголовок X-Admin-Token.
 */
const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'svet_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const t = getToken();
    if (t) headers['X-Admin-Token'] = t;
  }
  const resp = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await resp.json().catch(() => ({}));
  if (resp.status === 401 && auth) {
    clearToken();
    const err = new Error(data.detail || 'unauthorized');
    err.status = 401;
    throw err;
  }
  if (!resp.ok) {
    const err = new Error(data.detail || `HTTP ${resp.status}`);
    err.status = resp.status;
    throw err;
  }
  return data;
}

export const adminApi = {
  login: (password) => request('/api/admin/login', { method: 'POST', body: { password }, auth: false }),
  logout: () => request('/api/admin/logout', { method: 'POST' }),
  today: () => request('/api/admin/today'),
  events: (days = 7) => request(`/api/admin/events?days=${days}`),
  updateRequest: (id, status) => request(`/api/admin/request/${id}`, { method: 'PATCH', body: { status } }),
  setReception: (reception) => request('/api/admin/reception', { method: 'POST', body: { reception } }),
  metrics: (days = 30) => request(`/api/admin/metrics?days=${days}`),
  // Контент сайта
  contentAll: () => request('/api/admin/content'),
  contentBlock: (id) => request(`/api/admin/content/${id}`),
  contentUpdate: (id, data) => request(`/api/admin/content/${id}`, { method: 'PUT', body: { data } }),
  contentAddItem: (blockId, item) => request(`/api/admin/content/${blockId}/items`, { method: 'POST', body: { item } }),
  contentUpdateItem: (blockId, itemId, item) => request(`/api/admin/content/${blockId}/items/${itemId}`, { method: 'PUT', body: { item } }),
  contentDeleteItem: (blockId, itemId) => request(`/api/admin/content/${blockId}/items/${itemId}`, { method: 'DELETE' }),
  // Аня-Оператор (предложения правок + история)
  contentApply: (block_id, new_data, summary) => request('/api/admin/content-apply', { method: 'POST', body: { block_id, new_data, summary } }),
  contentUndo: () => request('/api/admin/content-undo', { method: 'POST' }),
  contentHistory: (limit = 20) => request(`/api/admin/content-history?limit=${limit}`),
  // Расписание приёма
  scheduleGet: () => request('/api/admin/schedule'),
  scheduleUpdate: (data) => request('/api/admin/schedule', { method: 'PUT', body: data }),
  // База знаний (шифрованная)
  knowledgeStatus: () => request('/api/admin/knowledge/status'),
  knowledgeGet: () => request('/api/admin/knowledge'),
  knowledgeUpdate: (sectionId, fields, password) => request(`/api/admin/knowledge/${sectionId}`, { method: 'PUT', body: { fields, password } }),
};
